import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import { fileupload, leftArrow } from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { file_post, get } from "../../Services/ApiHandler";
import { FaEye } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { Toast } from "bootstrap";

const TransportView = () => {
  //   const tabs = ["Transport Details", "Vehicles", "Drivers", "Bookings"];
  const tabs = [
    { name: "Transport Details", path: "/view-transport" },
    { name: "Vehicles", path: "/vehicle-transport" },
    { name: "Drivers", path: "/drivers-transport" },
    { name: "Bookings", path: "/transport-bookings" },
  ];
  const [step, setStep] = useState(1);
  const navigation = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [viewerFile, setViewerFile] = useState("");
  const [viewerOpen, setViewerOpen] = useState(false);

  //   const location = useLocation();
  //   const { data, type } = location.state || {};
  const location = useLocation();
  const { type, datas, data } = location.state || {};
  console.log(type); // "view"
  //   console.log(data); // row data
  // const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [transDat, setTransportDat] = useState(null);
  const [transview, setTransView] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const fileRefs = useRef({});

  const openFileViewer = (fileUrl) => {
    setViewerFile(fileUrl);
    setViewerOpen(true);
  };

  const [formData, setFormData] = useState({
    transport_name: "",
    owner_name: "",
    mobilenumber: "",
    email_id: "",
    property_tax: "",
    rental_agreement: "",
    gst_certificate: "",
    pancard: "",
    panproperietor: "",
    companyregisteration: "",
    msmeregisteration: "",
    laborlicence: "",
    bankpassbook: "",
    cancelledcheque: "",
    bankaccountname: "",
    ifsc: "",
    accountno: "",
    branch: "",
    companydeclarations: "",
    ndaagreement: "",
    agreementcopy: "",
    authorizationletter: "",
  });

  // ----------- FORM FIELDS -----------
  const fields = [
    {
      type: 1,
      title: "Add Transport Details",
      subtitle: "Contact & Address Proof",
      data: [
        {
          id: 1,
          name: "transport_name",
          label: "Transport Name",
          placeholder: "Enter Transport Name",
          fileupload: false,
          //   value: formData?.transport_name,
        },
        {
          id: 2,
          name: "owner_name",
          label: "Owner Name",
          placeholder: "Enter Owner Name",
          fileupload: false,
          //   value: formData?.Owner_name,
        },
        {
          id: 3,
          name: "mobilenumber",
          label: "Mobile number",
          placeholder: "Enter Mobile Number",
          fileupload: false,
          value: formData?.mobilenumber,
          readOnly: true,
        },
        {
          id: 4,
          name: "email_id",
          label: "Email ID",
          placeholder: "Enter your Email",
          fileupload: false,
          //   value: formData?.email_id,
        },
        {
          id: 5,
          name: "property_tax",
          label: "Property Tax",
          placeholder: "Property tax PDF",
          fileupload: true,
          //   value: formData?.property_tax,
        },
        {
          id: 6,
          name: "rental_agreement",
          label: "Rental Agreement",
          placeholder: "Rental Agreement.PDF",
          fileupload: true,
          //   value: formData?.rental_agreement,
        },
      ],
    },
    {
      type: 2,
      title: "Add Transport Details",
      subtitle: "Business & identity Proofs",
      data: [
        {
          id: 1,
          name: "gst_certificate",
          label: "GST Certificate",
          placeholder: "Upload GST Certificate (PDF)",
          fileupload: true,
          //   value: formData?.gst_certificate,
        },
        {
          id: 2,
          name: "pancard",
          label: "PAN Card (Company)",
          placeholder: "Upload Company PAN Card (PDF)",
          fileupload: true,
          //   value: formData?.pancard,
        },
        {
          id: 3,
          name: "panproperietor",
          label: "PAN Card (Proprietor)",
          placeholder: "Upload Proprietor PAN Card (PDF)",
          fileupload: true,
          //   value: formData?.panproperietor,
        },
        {
          id: 4,
          name: "companyregisteration",
          label: "Company Registration Documents",
          placeholder: "Upload Company Registration Certificate (PDF)",
          fileupload: true,
          //   value: formData?.companyregisteration,
        },
        {
          id: 5,
          name: "msmeregisteration",
          label: "MSME Registration",
          placeholder: "Upload MSME Registration Certificate (PDF)",
          fileupload: true,
          //   value: formData?.msmeregisteration,
        },
        {
          id: 6,
          name: "laborlicence",
          label: "Labor License",
          placeholder: "Upload Labor License Certificate (PDF)",
          fileupload: true,
          //   value: formData?.laborlicence,
        },
      ],
    },
    {
      type: 3,
      title: "Add Transport Details",
      subtitle: "Banking & Financial Documents",
      data: [
        {
          id: 1,
          name: "bankpassbook",
          label: "Bank Passbook",
          placeholder: "Bank Passbook.PDF",
          fileupload: true,
          //   value: formData?.bankpassbook,
        },
        {
          id: 2,
          name: "cancelledcheque",
          label: "Cancelled Cheque",
          placeholder: "Cancelled Cheque.PDF",
          fileupload: true,
          //   value: formData?.cancelledcheque,
        },
        {
          id: 3,
          name: "bankaccountname",
          label: "Bank Account Name",
          placeholder: "Enter Name",
          fileupload: false,
          //   value: formData?.bankaccountname,
        },
        {
          id: 4,
          name: "ifsc",
          label: "IFSC (EX:SBIN0001234)",
          placeholder: "Enter IFSC Code",
          fileupload: false,
          //   value: formData?.ifsc,
        },
        {
          id: 5,
          name: "accountno",
          label: "Bank Account No",
          placeholder: "Enter Bank Account NO",
          fileupload: false,
          //   value: formData?.accountno,
        },
        {
          id: 6,
          name: "branch",
          label: "Branch",
          placeholder: "Enter Branch",
          fileupload: false,
          //   value: formData?.branch,
        },
      ],
    },
    {
      type: 4,
      title: "Add Transport Details",
      subtitle: "Company Declarations",
      data: [
        {
          id: 1,
          name: "companydeclarations",
          label: "Company Declarations",
          placeholder: "upload companydeclarations.PDF",
          fileupload: true,
          //   value: formData?.companydeclarations,
        },
        {
          id: 2,
          name: "ndaagreement",
          label: "NDA Agreement.PDF",
          placeholder: "upload ndaagreement.PDF",
          fileupload: true,
          //   value: formData?.ndaagreement,
        },
        {
          id: 3,
          name: "agreementcopy",
          label: "Agreement/Contract Copy",
          placeholder: "uploadagreementcopy",
          fileupload: true,
          //   value: formData?.agreementcopy,
        },
        {
          id: 4,
          name: "authorizationletter",
          label: "Authorization Letter",
          placeholder: "upload authorizationletter",
          fileupload: true,
          //   value: formData?.authorizationletter,
        },
        // { id: 5, label: "Bank Account No", placeholder: "Enter Bank Account NO", fileupload: false },
        // { id: 6, label: "Branch", placeholder: "Enter Branch", fileupload: false },
      ],
    },
  ];

  // ----------- GET CURRENT STEP DATA -----------
  const currentSection = fields.find((item) => item.type === step);

  // ----------- NEXT BUTTON -----------
  const handleNext = () => {
    if (step < fields.length) {
      setStep(step + 1);
    }
  };

  // ----------- BACK BUTTON -----------
  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    } else {
      navigation(-1);
    }
  };

  const handleFileChange = (e, id, name) => {
    const file = e.target.files[0];

    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [id]: file.name, // store file name
      }));
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    }
  };

  const gettransportList = async () => {
    try {
      const res = await get(`${URLS.TRANSPORT_VIEW}?transport_id=${datas?.id}`);
      console.log("res", res);
      setTransView(res?.data);
      const data = res?.data[0];
      console.log("res dataaa", data, type);

      if (data && type === "view") {
        setFormData({
          transport_name: data?.name || "",
          owner_name: data?.owner_name || data?.owner_name || "",
          mobilenumber: data?.mobilenumber || data?.mobile || "",
          email_id: data?.email_id || data?.email || "",

          property_tax: data?.property_tax || "",
          rental_agreement: data?.rental_aggrement || "",
          gst_certificate: data?.gst || "",
          pancard: data?.pan_company || "",
          panproperietor: data?.pan_proprietor || "",
          companyregisteration: data?.company_registration || "",
          msmeregisteration: data?.msme_registration || "",
          laborlicence: data?.labour_licence || "",
          bankpassbook: data?.bank_passbook || "",
          cancelledcheque: data?.cancelled_cheque || "",

          bankaccountname: data?.acc_name || "",
          ifsc: data?.ifsc || "",
          accountno: data?.acc_no || "",
          branch: data?.branch || "",

          companydeclarations: data?.company_declaration || "",
          ndaagreement: data?.nda_aggrement || "",
          agreementcopy: data?.contract_copy || "",
          authorizationletter: data?.authorization_letter || "",
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const TransPost = async () => {
    const payload = new FormData();
    payload.append("step", String(step));

    const appendTextField = (key, value) => {
      payload.append(key, value ?? "");
    };

    const urlToFile = async (url, fallbackName) => {
      const response = await fetch(url);
      const blob = await response.blob();
      const fileNameFromUrl = url.split("/").pop()?.split("?")[0];
      const fileName = fileNameFromUrl || fallbackName;
      return new File([blob], fileName, {
        type: blob.type || "application/octet-stream",
      });
    };

    const appendBinaryField = async (key, value, fallbackName) => {
      if (value instanceof File) {
        payload.append(key, value, value.name);
        return;
      }

      if (typeof value === "string" && value.trim()) {
        try {
          const file = await urlToFile(value, fallbackName);
          payload.append(key, file, file.name);
        } catch (error) {
          console.log(`Binary conversion failed for ${key}`, error);
        }
      }
    };

    if (step === 1) {
      appendTextField("transport_id", datas?.id);
      appendTextField("name", formData?.transport_name);
      appendTextField("owner_name", formData?.owner_name);
      appendTextField("mobile", formData?.mobilenumber);
      appendTextField("email", formData?.email_id);
      await appendBinaryField(
        "rental_aggrement",
        formData?.rental_agreement,
        "rental_agreement",
      );
      await appendBinaryField(
        "property_tax",
        formData?.property_tax,
        "property_tax",
      );
    } else if (step === 2) {
      appendTextField("transport_id", datas?.id);
      await appendBinaryField(
        "gst",
        formData?.gst_certificate,
        "gst_certificate",
      );
      await appendBinaryField("pan_company", formData?.pancard, "pan_company");
      await appendBinaryField(
        "pan_proprietor",
        formData?.panproperietor,
        "pan_proprietor",
      );
      await appendBinaryField(
        "company_registration",
        formData?.companyregisteration,
        "company_registration",
      );
      await appendBinaryField(
        "msme_registration",
        formData?.msmeregisteration,
        "msme_registration",
      );
      await appendBinaryField(
        "labour_licence",
        formData?.laborlicence,
        "labour_licence",
      );
    } else if (step === 3) {
      appendTextField("transport_id", datas?.id);
      await appendBinaryField(
        "bank_passbook",
        formData?.bankpassbook,
        "bank_passbook",
      );
      await appendBinaryField(
        "cancelled_cheque",
        formData?.cancelledcheque,
        "cancelled_cheque",
      );
      appendTextField("acc_name", formData?.bankaccountname);
      appendTextField("acc_no", formData?.accountno);
      appendTextField("ifsc", formData?.ifsc);
      appendTextField("branch", formData?.branch);
    } else if (step === 4) {
      appendTextField("transport_id", datas?.id);
      await appendBinaryField(
        "company_declaration",
        formData?.companydeclarations,
        "company_declaration",
      );
      await appendBinaryField(
        "contract_copy",
        formData?.agreementcopy,
        "contract_copy",
      );
      await appendBinaryField(
        "authorization_letter",
        formData?.authorizationletter,
        "authorization_letter",
      );
      await appendBinaryField(
        "nda_aggrement",
        formData?.ndaagreement,
        "nda_aggrement",
      );
    }

    // setLoading(true);
    const res = await file_post(URLS.TRANSPORT_ADD, payload);
    console.log("res add trans", res);
    if (res?.status === "success") {
      setIsEditing(false);
      if (step === 1) {
        setTransportDat(res?.transport_id);
      }
      // setLoading(false);
      if (step < fields.length) {
        setStep(step + 1);
      } else {
        // setLoading(false);
      }
      if (step === 4) {
        navigation("/transport");
      }
    }
    // setLoading(false);
  };

  const validateSection = (currentStep) => {
    if (currentStep === 1) {
      if (!formData.transport_name) {
        toast("Transport Name is required");
        return false;
      }
      if (!formData.owner_name) {
        toast("Owner Name is required");
        return false;
      }
      if (!formData.mobilenumber) {
        toast("Mobile Number is required");
        return false;
      }
      if (!formData.email_id) {
        toast("Email is required");
        return false;
      }
      if (!formData.property_tax) {
        toast.error("Property Tax file is required");
        return false;
      }
      if (!formData.rental_agreement) {
        toast.error("Rental Agreement file is required");
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(formData.email_id)) {
        toast.error("Enter valid email address");
        return false;
      }
    }

    if (currentStep === 2) {
      if (!formData.gst_certificate) {
        toast.error("GST Certificate file is required");
        return false;
      }
      if (!formData.pancard) {
        toast.error("Pancard  is required");
        return false;
      }
      if (!formData.companyregisteration) {
        toast.error("Company Registration is required");
        return false;
      }
      if (!formData.msmeregisteration) {
        toast.error("MSME Registration is required");
        return false;
      }
      if (!formData.laborlicence) {
        toast.error("Labor Licence file is required");
        return false;
      }
    }

    if (currentStep === 3) {
      if (!formData.bankpassbook) {
        toast.error("Bank Passbook is required");
        return false;
      }
      if (!formData.cancelledcheque) {
        toast.error("Cancelled Cheque is required");
        return false;
      }
      if (!formData.bankaccountname) {
        toast.error("Bank Account Name is required");
        return false;
      }
      if (!formData.ifsc) {
        toast.error("IFSC is required");
        return false;
      }
      if (!formData.accountno) {
        toast.error("Bank Account Number is required");
        return false;
      }
      if (!formData.branch) {
        toast.error("Branch is required");
        return false;
      }
    }

    if (currentStep === 4) {
      if (!formData.companydeclarations) {
        toast.error("Company declaration is required");
        return false;
      } 
      if (!formData.ndaagreement) {
        toast.error("NDA Agreement is required");
        return false;
      } 
      if (!formData.agreementcopy) {
        toast.error("Agreement Copy is required");
        return false;
      } 
      if (!formData.authorizationletter) {
        toast.error("Authorization Letter is required");
        return false;
      } 
    }

      const accountRegex = /^[0-9]{9,18}$/;

      if (!accountRegex.test(formData.accountno)) {
        toast.error("Enter valid Bank Account Number (9-18 digits)");
        return false;
      }
      
      // if (!formData.ifsc) {
      //   toast.error("IFSC Code is required");
      //   return false;
      // }
      
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

      if (!ifscRegex.test(formData.ifsc)) {
        toast.error("Enter valid IFSC Code (e.g., SBIN0001234)");
        return false;
      }

    return true;
  };

  const handleSave = async () => {
    if (!validateSection(step)) return;
    // setIsLoading(true);
    // await TransPost();
    // setIsLoading(false);
    try {
      setIsLoading(true);
      await TransPost();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    gettransportList();
  }, []);

  useEffect(() => {
    // if (datas) {
    //   setFormData({
    //     transport_name: datas.transport_name || "",
    //     owner_name: datas.owner_name || "",
    //     mobilenumber: datas.mobile || "",
    //     email_id: datas.email_id || "",
    //   });
    // }

    if (type === "view") {
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  }, [datas, type]);

  const handleTabClick = (tab, index) => {
    setStep(index + 1);
    navigation(tab.path, { state: { datas, type } });
  };

  return (
    <>
      <Header />

      <div
        style={{ marginTop: "6rem", paddingLeft: "15px", paddingRight: "10px" }}
      >
        {/* <h5 className="title">Swift way Transports</h5> */}
        <div className="section">
          <h3 onClick={handleBack} className="section-titlez mb-0">
            {/* <img src={leftArrow} style={{ marginRight: 10 }} className="back-icon-arrow" alt="" /> */}

            {datas?.transport_name || ""}
          </h3>
        </div>

        {/* Tabs */}
        <div className="tabs mb-0 ms-3">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(tab, index)}
              //   className={`tab-btn ${step === index + 1 ? "active" : ""}`}
              className={`tab-btn ${
                location.pathname === tab.path ? "active" : ""
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Section Title */}
        <div className="section">
          <h3 onClick={handleBack} className="section-titlez">
            <img
              src={leftArrow}
              style={{ marginRight: 10 }}
              className="back-icon-arrow"
              alt=""
            />
            {currentSection?.title}
          </h3>
          <h6 onClick={handleBack} className="text-warning mb-3">
            {/* <img src={leftArrow} style={{ marginRight: 10 }} className="back-icon-arrow" alt="" /> */}
            {currentSection?.subtitle}
          </h6>

          {/* FORM GRID */}
          <div className="form-grid">
            {currentSection?.data.map((item) => {
              const uniqueId = `${currentSection.type}-${item.id}`;
              // const currentFileValue =
              //   uploadedFiles[uniqueId] ||
              //   (formData[item.name] instanceof File
              //     ? formData[item.name].name
              //     : formData[item.name] || "");
              const currentFileValue =
                uploadedFiles[uniqueId] || formData[item.name]
                  ? `${item.label} `
                  : "";
              //           const currentFileValue =
              // uploadedFiles[uniqueId] ||
              // (formData[item.name] instanceof File
              //   ? formData[item.name].name
              //   : typeof formData[item.name] === "string" && formData[item.name]
              //   ? formData[item.name].split("/").pop()
              //   : "");

              return (
                <div className="form-groupz" key={uniqueId}>
                  <label>{item.label}</label>

                  {item.fileupload ? (
                    <div
                      className="upload-boxz"
                      onClick={() => {
                        if (isEditing) {
                          fileRefs.current[uniqueId]?.click();
                        }
                      }}
                      style={{ cursor: isEditing ? "pointer" : "default" }}
                    >
                      {/* <input
                      type="text"
                      placeholder={item.placeholder}
                      readOnly
                    /> */}
                      <input
                        type="text"
                        placeholder={item.placeholder}
                        value={currentFileValue}
                        readOnly
                      />

                      <input
                        type="file"
                        // id={`file-${uniqueId}`}
                        ref={(el) => (fileRefs.current[uniqueId] = el)}
                        onChange={(e) =>
                          handleFileChange(e, uniqueId, item.name)
                        }
                        style={{ display: "none" }}
                        disabled={!isEditing}
                      />
                      {/* <label
                        htmlFor={`file-${uniqueId}`}
                        className="upload-btn"
                        style={{
                          pointerEvents: isEditing ? "auto" : "none",
                          opacity: isEditing ? 1 : 0.6,
                        }}
                      >
                        <img src={fileupload} alt="" className="uploadIcon" />
                      </label> */}
                      {/* ICON SWITCH */}

                      {isEditing ? (
                        /* Upload icon in edit mode */

                        <img
                          src={fileupload}
                          alt="upload"
                          className="uploadIcon"
                          onClick={(e) => {
                            e.stopPropagation();
                            fileRefs.current[uniqueId]?.click();
                          }}
                        />
                      ) : (
                        /* Eye icon in view mode */

                        formData[item.name] && (
                          <FaEye
                            className="viewIcon"
                            style={{
                              cursor: "pointer",
                              fontSize: "18px",
                              marginRight: 10,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openFileViewer(formData[item.name]);
                            }}
                          />
                        )
                      )}
                      {/* <label htmlFor={`file-${item.id}`} className="upload-btn">
                        <img src={fileupload} alt="" className="uploadIcon" />
                      </label> */}
                    </div>
                  ) : (
                    // <input
                    //     type="text"
                    //     placeholder={item.placeholder}
                    //     className="fileinput"
                    // />
                    <input
                      type="text"
                      placeholder={item.placeholder}
                      className="fileinput"
                      value={formData[item.name] || ""}
                      // onChange={(e) =>
                      //   setFormData({
                      //     ...formData,
                      //     [item.name]: e.target.value,
                      //   })
                      // }
                      onChange={(e) => {
                        let value = e.target.value;

                        // 👉 BANK ACCOUNT NUMBER VALIDATION (LIVE)
                        if (item.name === "accountno") {
                          value = value.replace(/\D/g, ""); // allow only numbers
                        }

                        // 👉 IFSC VALIDATION (UPPERCASE + LIMIT)
                        if (item.name === "ifsc") {
                          value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                        }

                        setFormData({
                          ...formData,
                          [item.name]: value,
                        });
                      }}
                      maxLength={
                        item.name === "accountno"
                          ? 18
                          : item.name === "ifsc"
                            ? 11
                            : undefined
                      }
                      readOnly={item?.readOnly || !isEditing}
                    />
                  )}
                </div>
              );
            })}
          </div>

          {/* ACTION BUTTONS */}
          <div className="actions">
            <button
              onClick={() => {
                isEditing ? handleSave() : setIsEditing(!isEditing);
              }}
              className={isEditing ? "save-btn" : "edit-btn"}
              disabled={isLoading}
            >
              {/* {isEditing ? "Save" : "Edit"} */}
              {isEditing ? (
                isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Save"
                )
              ) : (
                "Edit"
              )}
            </button>

            {!isEditing && step < fields.length && (
              <button onClick={handleNext} className="resolve-btn">
                Next
              </button>
            )}
          </div>
        </div>

        <Modal
          show={viewerOpen}
          onHide={() => setViewerOpen(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Document Viewer</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ height: "80vh" }}>
            {viewerFile?.toLowerCase().endsWith(".pdf") ? (
              <iframe
                src={`${viewerFile}#toolbar=0`}
                title="PDF Viewer"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            ) : (
              <img
                src={viewerFile}
                alt="Document"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default TransportView;
